// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__1Bgf_","content":"SubHeader_content__2Cfn4","btnBack":"SubHeader_btnBack__JrQs7","line":"SubHeader_line__2x6Ma"};